import { Box, styled } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { Control, Controller } from "react-hook-form"
import { TextField } from "@tm/controls"
import { GeneralCustomerFields } from "./GeneralCustomerFields"

type FieldColProps = {
    width?: string
    label: number
    fieldName: keyof GeneralCustomerFields
    onUpdateFieldValue: (path: keyof GeneralCustomerFields, value: string | undefined) => void
    control: Control<GeneralCustomerFields, any>
}

const StyledBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(0.5, 1, 0.5, 0),
    width: "15em",
}))

export default function FieldCol({ width = "12em", label, fieldName, onUpdateFieldValue, control }: FieldColProps) {
    const { translateText } = useLocalization()

    return (
        <StyledBox sx={{ width }}>
            <Controller
                name={fieldName}
                control={control}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        value={field.value ?? ""}
                        label={translateText(label)}
                        onChange={(e) => {
                            field.onChange(e ?? "")
                            onUpdateFieldValue(field.name, e ?? "")
                        }}
                        size="s"
                        fieldState={fieldState}
                        path={[field.name]}
                    />
                )}
            />
        </StyledBox>
    )
}
